<template lang="pug">
	.audio-tracker-select-menu.flex-col.center.align-left
		div.title {{$tCaption('Impulse Response')}}
		select(v-model="selected" @change="selectOption(selected)")
			option(:value="option.value" v-for="option, index in options" ) {{option.name}}
</template>

<script>
	import VueTypes from 'vue-types';

	export default {
		translationCategory: 'audioTracker.AudioTrackerSelectMenu',
		name: 'audio-tracker-select-menu',
		components: {},
		props: {
			options: VueTypes.array.def([]),
			value: VueTypes.any.def(null)
		},
		computed: {},
		watch: {},
		mounted() {},
		data() {
			return {
				selected: this.value,
			};
		},
		methods: {
			selectOption(selected) {
				if (__DEBUG__)
					console.debug('On change', { selected });
				this.selected = selected;
				this.$emit('change', this.selected);
			}
		}
	}
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	select {
		width: 100%;
		background: inherit;
		color: white;
		margin-bottom: 1rem;

		> option {
			margin: 40px;
			background: #424248;
			color: #fff;
		}
	}
	.title {
		margin-bottom: .5rem;
	}
</style>
